import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function fmt(val) {
  return parseFloat(val || 0).toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const LOAD_TYPES = [
  { value: 'contenedor_paletizado', label: 'Contenedor Paletizado' },
  { value: 'contenedor_granel', label: 'Contenedor Granel' },
  { value: 'paletizado_bajo_cubierta', label: 'Paletizado Bajo Cubierta' },
  { value: 'granel_bajo_cubierta', label: 'Granel Bajo Cubierta' },
];

export default function BidFormModal({ quota, onClose, onSave, saving }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    quota: quota.id,
    boxes_requested: '',
    price_per_box: '',
    brand: '',
    payment_terms: 'contado',
    pickup_location: '',
    load_type: '',
    notes: '',
  });

  const total = (parseFloat(form.boxes_requested) || 0) * (parseFloat(form.price_per_box) || 0);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <div className="bmp-modal-overlay" onClick={onClose}>
      <div className="bmp-modal" onClick={e => e.stopPropagation()}>
        <div className="bmp-modal-header">
          <h3>{t('bmp_make_bid')} — {quota.farm_name}</h3>
          <button className="bmp-modal-close" onClick={onClose}>&#10005;</button>
        </div>
        <div style={{ padding: '8px 20px', background: 'var(--bmp-bg)', fontSize: 13, color: 'var(--bmp-text-muted)' }}>
          {t('bmp_boxes_available')}: <strong>{quota.remaining_boxes.toLocaleString('es-EC')}</strong>
        </div>
        <form onSubmit={handleSubmit} className="bmp-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="bmp-form-row">
            <div className="bmp-field">
              <label>{t('mkt_boxes_requested')}</label>
              <input type="number" min="1" max={quota.remaining_boxes} value={form.boxes_requested} onChange={e => setForm(f => ({ ...f, boxes_requested: e.target.value }))} required />
            </div>
            <div className="bmp-field">
              <label>{t('mkt_price_per_box')}</label>
              <input type="number" step="0.01" min="0" value={form.price_per_box} onChange={e => setForm(f => ({ ...f, price_per_box: e.target.value }))} required placeholder="$0.00" />
            </div>
            <div className="bmp-field">
              <label>{t('mkt_brand')}</label>
              <input type="text" value={form.brand} onChange={e => setForm(f => ({ ...f, brand: e.target.value }))} placeholder={t('mkt_brand_placeholder')} />
            </div>
          </div>
          <div className="bmp-form-row">
            <div className="bmp-field">
              <label>{t('mkt_payment_terms')}</label>
              <select value={form.payment_terms} onChange={e => setForm(f => ({ ...f, payment_terms: e.target.value }))}>
                <option value="contado">{t('mkt_pay_cash')}</option>
                <option value="50_50">50/50</option>
                <option value="8_dias">{t('mkt_pay_8days')}</option>
              </select>
            </div>
            <div className="bmp-field">
              <label>{t('mkt_pickup')}</label>
              <input type="text" value={form.pickup_location} onChange={e => setForm(f => ({ ...f, pickup_location: e.target.value }))} placeholder={t('mkt_pickup_placeholder')} />
            </div>
            <div className="bmp-field">
              <label>{t('mkt_load_type')}</label>
              <select value={form.load_type} onChange={e => setForm(f => ({ ...f, load_type: e.target.value }))}>
                <option value="">—</option>
                {LOAD_TYPES.map(lt => <option key={lt.value} value={lt.value}>{lt.label}</option>)}
              </select>
            </div>
          </div>

          {total > 0 && (
            <div style={{ background: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: 6, padding: '10px 14px', fontSize: 16, color: '#2e7d32' }}>
              Total: <strong>${fmt(total)}</strong>
            </div>
          )}

          <div className="bmp-field">
            <label>{t('mkt_notes')}</label>
            <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} rows={2} placeholder={t('mkt_notes_placeholder')} />
          </div>
          <div className="bmp-form-actions">
            <button type="button" className="bmp-btn bmp-btn-secondary" onClick={onClose}>{t('cancel')}</button>
            <button type="submit" className="bmp-btn bmp-btn-primary" disabled={saving}>{saving ? t('saving') : t('mkt_send_bid')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
